export default {
  state: {
    apiBaseUrl: process.env.API_BASE_URL
  },

  getters: {
    config: (state) => state
  }
};
